import { Chart } from 'react-google-charts';
import { formatDate } from '../../../format-date';

export const TempChart = ({ data, widthWindow }) => {
    const titleMob = data &&
        `Температура з ${formatDate(data[0].dt_txt)} по ${formatDate(data[data.length - 1].dt_txt)}, °С`;
    const options = {
        title: `${widthWindow <= 650 ? titleMob : 'Температура на 5 днів, °С'}`,
        titleTextStyle: {
            textAlign: 'center',
            color: '#4d4de9'
        },
        axisTitlesPosition: 'none',
        chartArea: { width: '90%' },
        legend: widthWindow <= 650 ? { position: 'none' } : { position: 'top', alignment: 'end' },
        colors: ['#8f8fee'],
        backgroundColor: { fillOpacity: 0.6 },
    };
    const tempDate = [['Date', 'Температура', { role: 'annotation' }]];
    tempDate.push(...data.map(item =>
        [formatDate(item.dt_txt), Math.ceil(item.main.temp), Math.ceil(item.main.temp)]));

    return (
        <div>
            <Chart
                chartType='SteppedAreaChart'
                width='100%'
                height='400px'
                data={tempDate}
                options={options}
            />
        </div>
    )
}